import { useEffect } from 'react'
import PropTypes from 'prop-types'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import ModalView from 'components/CommonUI/ModalView'
import Loader from 'components/Loader'
import Label from 'components/Label'
import { useAction } from 'utils/actions'

const ModalFlow = ({ 
  activeIndex, 
  setActiveIndex, 
  loaderLabel, 
  children, 
  ...props
}) => {
  const { setDrawerUtils } = useAction()

  useEffect(() => {
    setDrawerUtils({ activeIndex, setActiveIndex })
  }, [activeIndex, setActiveIndex])

  if (activeIndex === -1) {
    return (
      <ModalView 
        sizeX="md"
      >
        <Stack
          display="grid"
          justifyContent="center"
          justifyItems="center"
          alignContent="center"
          alignItems="center"
          p={3}
          minHeight="400px"
          textAlign="center"
        >
          <Loader variant="primary" />
          {!!loaderLabel && (
            <Label
              variant="dataBoldTertiaryUpperSpaced"
            >
              {loaderLabel}
            </Label>
          )}
        </Stack>
      </ModalView>
    )
  }

  return (
    <ModalView 
      {...props}
    >
      <Box
        sx={{
          overflowY: 'auto',
        }}
      >
        {children[activeIndex]}
      </Box>
    </ModalView>
  )
}

ModalFlow.propTypes = {
  activeIndex: PropTypes.number,
  loaderLabel: PropTypes.any,
}

ModalFlow.defaultProps = {
  activeIndex: 0,
}

export default ModalFlow
